var exports = {
  "kL": "x936d19a0--c58976--container",
  "nM": "x936d19a0--c58976--row",
  "IV": "x936d19a0--c58976--name-container",
  "DD": "x936d19a0--c58976--title",
  "s6": "x936d19a0--c58976--agent-name",
  "UU": "x936d19a0--c58976--name",
  "jp": "x936d19a0--c58976--badges",
  "Wl": "x936d19a0--c58976--avatar-container",
  "my": "x936d19a0--c58976--avatar",
  "i0": "x936d19a0--c58976--avatar_roundness",
  "_9": "x936d19a0--c58976--avatar_image",
  "Lr": "x936d19a0--c58976--no_photo",
  "O0": "x936d19a0--c58976--rating",
  "RY": "x936d19a0--c58976--rating-desctiption",
  "OK": "x936d19a0--c58976--counters",
  "EB": "x936d19a0--c58976--counters-item",
  "jG": "x936d19a0--c58976--description-container",
  "Lp": "x936d19a0--c58976--about-title",
  "uh": "x936d19a0--c58976--about-text",
  "wI": "x936d19a0--c58976--maximize-button",
};

module.exports = exports;
